import { FormHandles } from '@unform/core';
import { useConfiguracaoContext } from 'contexts/configuracao.context/hook.context';
import { YupUtilsCatch, YupUtilsTry } from 'libs/yup/ShapeValidation';
import { useMutationConfigDefault } from 'pages/unidades/modal/configuracao-padrao/hooks/useMutationConfigDefault';
import React, { createRef, FC } from 'react';
import ComponentConfiguracaoSaque from './Component';
import { yupValidationProps } from './validation';

const listTransformNumber = [
    'Saque_Ativo',
    'Saque_Aprovacao_Manual',
    'Saque_Valor_Minimo',
    'Saque_Retencao_Dias',
    'Saque_Prazo_Padrao_Dias',
    'Saque_Taxa_Antecipacao_Valor',
];

const PageConfiguracaoSaque: FC = () => {
    const { configuracao: defaultValues, loadingData } =
        useConfiguracaoContext();
    const { atualizaConfiguracaoSistema, loading } = useMutationConfigDefault();
    const rForm = createRef<FormHandles>();

    const handleSubmit = async (data: any) => {
        const { setErrors } = rForm.current as FormHandles;

        if (!data.Saque_Data_Corte) data.Saque_Data_Corte = undefined;
        listTransformNumber.forEach(key => {
            if (!data[key]) {
                data[key] = undefined;
            }
            if (data[key] && typeof data[key] === 'string') {
                data[key] = Number(data[key].replace(/[^0-9|\.]/gi, ''));
            }
        });

        try {
            await YupUtilsTry(data, setErrors, yupValidationProps);

            atualizaConfiguracaoSistema(data);
        } catch (err) {
            console.error(err);
            YupUtilsCatch(err, setErrors);
        }
    };

    const oProps = {
        rForm,
        defaultValues,
        loading,
        loadingData: !(
            !loadingData &&
            defaultValues &&
            Object.keys(defaultValues).length > 0
        ),
        handleSubmit,
    };
    return <ComponentConfiguracaoSaque {...oProps} />;
};
export default PageConfiguracaoSaque;
